import Box from '@mui/material/Box';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';
import { ReactNode } from 'react';

interface Props {
    icon: ReactNode;
    title: string;
    description: string;
    tone?: 'primary' | 'warning' | 'error';
}

export default function MaintenanceDialogTitle({
    icon,
    title,
    description,
    tone = 'primary'
}: Props) {
    return <DialogTitle>
        <Stack direction="row" spacing={1.5} alignItems="center">
            <Box sx={{
                width: 40,
                height: 40,
                flexShrink: 0,
                borderRadius: 2,
                display: 'grid',
                placeItems: 'center',
                color: `${tone}.main`,
                bgcolor: theme => alpha(theme.palette[tone].main, 0.1)
            }}>
                {icon}
            </Box>
            <Box>
                <Typography variant="h6">{title}</Typography>
                <Typography variant="body2" color="text.secondary">
                    {description}
                </Typography>
            </Box>
        </Stack>
    </DialogTitle>;
}
